export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/HamburgerIcon.19bcc28c.svg","height":14,"width":20,"blurWidth":0,"blurHeight":0};